import {Vector3} from '@babylonjs/core/Maths/math.vector';
import {PLAYER} from '../../config/GameConfig';
import {BASIL_CAPSULE_HEIGHT} from '../../entities/players/Basil';
import {CLOCKWORK_CANOPY_PLATFORMS} from './ClockworkCanopyPlatforms';
import {platformTop} from './types';

/** Fresh default poses on the entry deck. Saved poses retain their own owner. */
export function canopySpawns():{minnaSpawn:Vector3;basilSpawn:Vector3} {
  const deck=CLOCKWORK_CANOPY_PLATFORMS.platforms.find(p=>p.name==='plat_s1_1')!;
  const top=platformTop(deck);
  return {minnaSpawn:new Vector3(6,top+PLAYER.CAPSULE_HEIGHT/2,0),
    basilSpawn:new Vector3(8,top+BASIL_CAPSULE_HEIGHT/2,0)};
}
